import { ItemApi } from '@/apis';
import { ResponseData } from '@/types/http';
import { TableState } from '@tanstack/react-table';
import { flow, makeObservable, observable } from 'mobx';
import RootStore from '.';
import BaseStore from './BaseStore';

export default class ItemStore extends BaseStore {
    items: any[] = [];
    validData: any[] = [];
    invalidData: any[] = [];
    item: any = null;
    totalPage: number = 0;
    totalCoupon: number = 0;
    totalCouponUsed: number = 0;
    api: ItemApi;

    constructor(rootStore: RootStore) {
        super(rootStore);
        makeObservable(this, {
            items: observable,
            getAllItem: flow.bound,
            getItemsForMap: flow.bound,
            addItem: flow.bound,
            deleteItem: flow.bound,
            approveItem: flow.bound,
            rejectItem: flow.bound,
            uploadImage: flow.bound,
            getItemById: flow.bound,
            updateItem: flow.bound,
            uploadFileExcel: flow.bound
        });
        this.api = new ItemApi();
    }

    *getAllItem(searchParams: any, paging?: TableState) {
        try {
            const payload = { ...this.convertPagingFromTableToRequest(paging ?? this.paging), ...searchParams };
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.getAllItem, payload);
            if (res.ok) {
                this.items = res.data.elements;
                this.paging = {
                    ...this.paging,
                    sorting: paging?.sorting ?? [],
                    pagination: this.convertPaginationFromRequestToTable(res.data.paginate)
                };
                this.totalRecord = res.data.paginate.totalRecord;
                this.totalPage = res.data.paginate.totalPage;
                this.totalCoupon = res.data.itemCoupon.itemCouponCount;
                this.totalCouponUsed = res.data.itemCoupon.itemCouponCountUser;
            }
            return res;
        } catch (error) {
        }
    }

    // 運用マップ用の全件取得 (2026-09-17)。API の件数パラメータは `size` (`limit` は無視され既定 10 件になる)。
    // getAllItem と違い items / paging を書き換えない = アイテム管理一覧のページ設定を汚さない。
    *getItemsForMap(size: number) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.getAllItem, { page: 1, size });
            return res;
        } catch (error) {
        }
    }

    *getItemById(id: string) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.getItemById, id);
            if (res.ok) {
                this.item = res.data;
            }
            return res;
        } catch (error) {
        }
    }

    *addItem(payload: any) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.addItem, payload);
            if (res.ok) {
                return res;
            }
        } catch (error: any) {
            return error?.data;
        }
    }

    *updateItem(payload: any) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.updateItem, payload);
            return res;
        } catch (error) {
        }
    }

    *deleteItem(id: string) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.deleteItem, id);
            if (res.ok) {
                return res;
            }
        } catch (error: any) {
            return error?.data;
        }
    }

    *approveItem(id: number) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.approveItem, id);
            if (res.ok) {
                return res;
            }
        } catch (error: any) {
            return error?.data;
        }
    }

    *rejectItem(payload) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.rejectItem, payload);
            if (res.ok) {
                return res;
            }
        } catch (error: any) {
            return error?.data;
        }
    }

    *uploadImage(payload) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.uploadImage, payload);
            if (res.ok) {
                return res;
            }
        } catch (error) {
        }
    }

    *uploadFileExcel(payload) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.uploadFileExcel, payload);
            if (res.ok) {
                this.validData = res.data.validData;
                this.invalidData = res.data.invalidData;
                return res;
            }
        } catch (error: any) {
            return error?.data;
        }
    }

    clean(): void {
        super.clean();
        this.items = [];
        this.invalidData = [];
        this.validData = [];
    }
}
